import React, { createContext, useState } from "react";

export const StepContext = createContext({
  step: 1,
  setStep: () => {},
  deviceStep: 0,
  setDeviceStep: () => {},
});

export function StepProvider({ children }) {
  const [step, setStep] = useState(1);
  const [deviceStep, setDeviceStep] = useState(0);

  return (
    <StepContext.Provider value={{ step, setStep, deviceStep, setDeviceStep }}>
      {children}
    </StepContext.Provider>
  );
}
